import { createGetAllApi } from "@api/util/createGetAllApi";
import { createGetApi } from "@api/util/createGetApi";

import type { IApiResponse, IPagination, IPaginationParams } from "@api";

import type { IPathBaseParam, IPathByIdParam } from "./path";
import type { ICountriesResponse } from "./types";

const getAllApis = createGetAllApi<
  IApiResponse<IPagination<ICountriesResponse>>,
  IPathBaseParam,
  IPaginationParams
>("geo.countries");
const getApis = createGetApi<
  IApiResponse<ICountriesResponse>,
  IPathByIdParam,
  object
>("geo.countries");

export const countries = {
  ...getAllApis,
  ...getApis,
};
